import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ContainerComponent } from './container/container.component';
import { FilePreviewComponent } from './file-preview/file-preview.component';
import { FileUploadControlComponent } from './file-upload-control/file-upload-control.component';
import { CurrencySuffixPipe } from './pipes/currency-suffix.pipe';
import { ScreenAlertComponent } from './screen-alert/screen-alert.component';
import { LoaderComponent } from './loader/loader.component';
import { PropertyLoaderComponent } from './property-loader/property-loader.component';
import { BackButtonDirective } from './directives/back-button.directive';
import { InsufficientInfiniteScrollDirective } from './directives/insufficient-infinite-scroll.directive';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogoComponent } from './logo/logo.component';
import { AreaPipe } from './pipes/area.pipe';
import { DistancePipe } from './pipes/distance.pipe';
import { CleanValuePipe } from './pipes/cleanValue.pipe';
import { YesOrNoPipe } from './pipes/yesOrNo.pipe';
import { ProjectListPipe } from './pipes/projectList.pipe';
import { UiUploadedDocumentModule } from '@skychute/ui/uploaded-document';
import { StripePaymentMethodComponent } from './stripe-payment-method/stripe-payment-method.component';
import { BpayComponent } from './bpay/bpay.component';
import { PaginationComponent } from './pagination/pagination.component';
import { SortByAspectPipe } from './pipes/sort-by-aspect.pipe';
import { SortByAttachPipe } from './pipes/sort-by-attach.pipe';
import { AddressInputComponent } from './address-input/address-input.component';
import { UiModelsModule } from '@skychute/ui-models';
import { UiAlertModule } from '@skychute/ui/alert';
import { AusCurrencyPipe } from './pipes/aus-currency.pipe';
import { SpinLoaderComponent } from './spin-loader/spin-loader.component';
import { TeamSwitcherDialogComponent } from './team-switcher-dialog/team-switcher-dialog.component';
import { DealStatusComponent } from './deal-status/deal-status.component';
import { DealDepositStatusComponent } from './deal-deposit-status/deal-deposit-status.component';
import { AusCurrencyWithoutDecimalPipe } from './pipes/aus-currency-without-decimal.pipe';
import { NumericRangeComponent } from './numeric-range/numeric-range.component';
import { SearchComponent } from './search/search.component';
import { SortAttachmentByCustomOrderPipe } from './pipes/sort-attachment-by-custom-order.pipe';
import { SlideToggleComponent } from './slide-toggle/slide-toggle.component';
import { CdnModule } from '@skychute/cdn';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UnderscoreToSpace } from './pipes/underscore-to-space.pipe';
import { MatButtonModule } from '@angular/material/button';
import { ActivityLogComponent } from './activity-log/activity-log.component';
import { NgxTimelineModule } from '@frxjs/ngx-timeline';
import { CleanTextPipe } from './pipes/clean-text.pipe';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    InfiniteScrollModule,
    FormsModule,
    UiUploadedDocumentModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    UiModelsModule,
    UiAlertModule,
    CdnModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatButtonModule,
    NgxTimelineModule,
  ],
  declarations: [
    FilePreviewComponent,
    FileUploadControlComponent,
    ContainerComponent,
    CurrencySuffixPipe,
    AreaPipe,
    DistancePipe,
    CleanValuePipe,
    YesOrNoPipe,
    ProjectListPipe,
    ScreenAlertComponent,
    LoaderComponent,
    PropertyLoaderComponent,
    InsufficientInfiniteScrollDirective,
    BackButtonDirective,
    LogoComponent,
    StripePaymentMethodComponent,
    BpayComponent,
    PaginationComponent,
    SortByAspectPipe,
    SortByAttachPipe,
    AddressInputComponent,
    AusCurrencyPipe,
    AusCurrencyWithoutDecimalPipe,
    SpinLoaderComponent,
    TeamSwitcherDialogComponent,
    DealStatusComponent,
    DealDepositStatusComponent,
    NumericRangeComponent,
    SearchComponent,
    SortAttachmentByCustomOrderPipe,
    SlideToggleComponent,
    UnderscoreToSpace,
    ActivityLogComponent,
    CleanTextPipe
  ],
  exports: [
    FilePreviewComponent,
    FileUploadControlComponent,
    ContainerComponent,
    CurrencySuffixPipe,
    AreaPipe,
    DistancePipe,
    CleanValuePipe,
    YesOrNoPipe,
    ProjectListPipe,
    ScreenAlertComponent,
    LoaderComponent,
    PropertyLoaderComponent,
    InsufficientInfiniteScrollDirective,
    BackButtonDirective,
    LogoComponent,
    StripePaymentMethodComponent,
    BpayComponent,
    PaginationComponent,
    SortByAspectPipe,
    SortByAttachPipe,
    AddressInputComponent,
    AusCurrencyPipe,
    AusCurrencyWithoutDecimalPipe,
    SpinLoaderComponent,
    TeamSwitcherDialogComponent,
    DealDepositStatusComponent,
    DealStatusComponent,
    DealStatusComponent,
    NumericRangeComponent,
    SearchComponent,
    SortAttachmentByCustomOrderPipe,
    SlideToggleComponent,
    UnderscoreToSpace,
    ActivityLogComponent,
    CleanTextPipe
  ],
})
export class UiCommonModule {}
